module.exports = __webpack_public_path__ + "img/3.55b3c762.jpg";